import React from 'react'
import { Button, Icon, NotificationsStatusBar } from 'gu-ui-kit'
import styles from 'modules/Billing/Billing.module.scss'
import { ROUTES } from 'constants/routes'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const Notification = () => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['billing'])
  const pathGen = useGeneratePathI18n()

  return (
    <NotificationsStatusBar
      view={breakpoints.sm ? 's' : breakpoints.md ? 'm' : 'l'}
      color="static-Label-GU-Primary"
      before={
        <Icon
          name="emoji-fire"
          width={40}
          height={40}
        />
      }
      after={
        <Button
          component="a"
          className={styles['billing__info-button']}
          variant="primary"
          bgColor={'Interface-Onsurface'}
          color={'Background-Dark'}
          target="_blank"
          href={pathGen(ROUTES.PROMISED_PAYMENT_TERMS)}
        >
          {t('learn_more')}
        </Button>
      }
      className={styles['billing__info']}
    >
      <>
        <div className={styles['billing__info-heading']}>{t('promised_payment')}</div>
        <div className={styles['billing__info-summary']}>{t('promised_payment_service')}</div>
      </>
    </NotificationsStatusBar>
  )
}

export default Notification
